import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Customer from './customer';
import Contact from './contact';
import Address from './address';
import BankAccount from './bank-account';
import Organisation from './organisation';
import Employee from './employee';
import CustomerAccount from './customer-account';
import ProductOrder from './product-order';
import Invoice from './invoice';
import Product from './product';
import ProductOffering from './product-offering';
import ProductSpecification from './product-specification';
import ProductOfferingPrice from './product-offering-price';
import Ean from './ean';
import Tariff from './tariff';
import TaxTariffTranche from './tax-tariff-tranche';
import CustomerOrder from './customer-order';
import Agreement from './agreement';
import Supplier from './supplier';
import Department from './department';
import ServiceOrder from './service-order';
import WorkOrder from './work-order';
import Task from './task';
import Meter from './meter';
import DynamicTariff from './dynamic-tariff';
import DailyProductUsage from './daily-product-usage';
import HourlyProductUsage from './hourly-product-usage';
import MonthlyProductUsage from './monthly-product-usage';
import Login from './login';
import GridOperator from './grid-operator';
import GridOperatorCapacityTariff from './grid-operator-capacity-tariff';
import GridOperatorCapacity from './grid-operator-capacity';
import TariffHistory from './tariff-history';
import TaxTariffTrancheHistory from './tax-tariff-tranche-history';
import CorrectionFactor from './correction-factor';
import ErrorMessage from './error-message';
import SectorCalendar from './sector-calendar';
import ProductProcess from './product-process';
import ProductProcessHistory from './product-process-history';
import Mandate from './mandate';
import RelationCustomer from './relation-customer';
import SigningSession from './signing-session';
import ContractSignature from './contract-signature';
import SignatureAuditLog from './signature-audit-log';
import NetMeteringPolicy from './net-metering-policy';
import SubCaptar from './sub-captar';
import ProductTariffOverride from './product-tariff-override';
import TariffPricingConstraint from './tariff-pricing-constraint';
import ContactRms from './contact-rms';
/* jhipster-needle-add-route-import - JHipster will add routes here */

export default () => {
  return (
    <div>
      <ErrorBoundaryRoutes>
        {/* prettier-ignore */}
        <Route path="customer/*" element={<Customer />} />
        <Route path="contact/*" element={<Contact />} />
        <Route path="address/*" element={<Address />} />
        <Route path="bank-account/*" element={<BankAccount />} />
        <Route path="organisation/*" element={<Organisation />} />
        <Route path="employee/*" element={<Employee />} />
        <Route path="customer-account/*" element={<CustomerAccount />} />
        <Route path="product-order/*" element={<ProductOrder />} />
        <Route path="invoice/*" element={<Invoice />} />
        <Route path="product/*" element={<Product />} />
        <Route path="product-offering/*" element={<ProductOffering />} />
        <Route path="product-specification/*" element={<ProductSpecification />} />
        <Route path="product-offering-price/*" element={<ProductOfferingPrice />} />
        <Route path="ean/*" element={<Ean />} />
        <Route path="tariff/*" element={<Tariff />} />
        <Route path="tax-tariff-tranche/*" element={<TaxTariffTranche />} />
        <Route path="customer-order/*" element={<CustomerOrder />} />
        <Route path="agreement/*" element={<Agreement />} />
        <Route path="supplier/*" element={<Supplier />} />
        <Route path="department/*" element={<Department />} />
        <Route path="service-order/*" element={<ServiceOrder />} />
        <Route path="work-order/*" element={<WorkOrder />} />
        <Route path="task/*" element={<Task />} />
        <Route path="meter/*" element={<Meter />} />
        <Route path="dynamic-tariff/*" element={<DynamicTariff />} />
        <Route path="daily-product-usage/*" element={<DailyProductUsage />} />
        <Route path="hourly-product-usage/*" element={<HourlyProductUsage />} />
        <Route path="monthly-product-usage/*" element={<MonthlyProductUsage />} />
        <Route path="login/*" element={<Login />} />
        <Route path="grid-operator/*" element={<GridOperator />} />
        <Route path="grid-operator-capacity-tariff/*" element={<GridOperatorCapacityTariff />} />
        <Route path="grid-operator-capacity/*" element={<GridOperatorCapacity />} />
        <Route path="tariff-history/*" element={<TariffHistory />} />
        <Route path="tax-tariff-tranche-history/*" element={<TaxTariffTrancheHistory />} />
        <Route path="correction-factor/*" element={<CorrectionFactor />} />
        <Route path="error-message/*" element={<ErrorMessage />} />
        <Route path="sector-calendar/*" element={<SectorCalendar />} />
        <Route path="product-process/*" element={<ProductProcess />} />
        <Route path="product-process-history/*" element={<ProductProcessHistory />} />
        <Route path="mandate/*" element={<Mandate />} />
        <Route path="relation-customer/*" element={<RelationCustomer />} />
        <Route path="signing-session/*" element={<SigningSession />} />
        <Route path="contract-signature/*" element={<ContractSignature />} />
        <Route path="signature-audit-log/*" element={<SignatureAuditLog />} />
        <Route path="net-metering-policy/*" element={<NetMeteringPolicy />} />
        <Route path="sub-captar/*" element={<SubCaptar />} />
        <Route path="product-tariff-override/*" element={<ProductTariffOverride />} />
        <Route path="tariff-pricing-constraint/*" element={<TariffPricingConstraint />} />
        <Route path="contact-rms/*" element={<ContactRms />} />
        {/* jhipster-needle-add-route-path - JHipster will add routes here */}
      </ErrorBoundaryRoutes>
    </div>
  );
};
